import React from "react";
import Banner from "assets/items_banner.jpg";
import BannerWebP from "assets/items_banner.webp";
import { useTranslation } from "react-i18next";

const StartStep = (): JSX.Element => {
    const { t } = useTranslation();
 
    return <div>
        <div>
            <source srcSet={BannerWebP} type="image/webp" />
            <source srcSet={Banner} type="image/jpeg" />
            <img src={Banner} alt={t("Banner with an image of stacked cubes")} />
        </div>
    </div>

}

export default StartStep;
